/* Imports */
import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// const querystring = require('querystring');
/* Chart code */
// Themes begin
//am4core.useTheme(am4themes_animated);
// Themes end

export default class DemoChart extends Component {

constructor(props)
{
	console.log(props);
	super(props);

	let parms = "";
	// JSON.stringify(querystring.parse(window.location.search)).replace('?', '');
	this.state = {
		locationName : JSON.parse(parms).locationName
	}

}

componentDidMount()
{
    let chartTemperature = am4core.create("chartTemperatureDiv", am4charts.XYChart);
    let chartHumidity = am4core.create("chartHumidityDiv", am4charts.XYChart);
    let chartPressure = am4core.create("chartPressureDiv", am4charts.XYChart);
    let chartAmbience1 = am4core.create("chartAmbience1Div", am4charts.XYChart);
    let chartAmbience2 = am4core.create("chartAmbience2Div", am4charts.XYChart);
    let chartMoisture = am4core.create("chartMoistureDiv", am4charts.XYChart);

    let data = [];
    let visits = 10;
    for (let i = 1; i < 366; i++) {
      visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }

	this.setupTemperatureChart(chartTemperature, data);
	this.setupHumidityChart(chartHumidity, data);
	this.setupPressureChart(chartPressure, data);
	this.setupAmbience1Chart(chartAmbience1, data);
	this.setupAmbience2Chart(chartAmbience2, data);
	this.setupMoistureChart(chartMoisture, data);

    
}
	/***
		Temperature Chart
	***/
	setupTemperatureChart(chartTemperature, data)
	{
    chartTemperature.paddingRight = 20;


    chartTemperature.data = data;
	let title = chartTemperature.titles.create();
	title.text = 'Temperature';
	title.fontSize = 20;
    let dateAxis = chartTemperature.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartTemperature.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartTemperature.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartTemperature.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartTemperature.scrollbarX = scrollbarX;

    this.chartTemperature = chartTemperature;
	}

	/***
		Humidity Chart
	***/
	setupHumidityChart(chartHumidity, data)
	{
    chartHumidity.paddingRight = 20;
	data = [];
    let visits = 20;
    for (let i = 1; i < 200; i++) {
      visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }

    chartHumidity.data = data;
	let title = chartHumidity.titles.create();
	title.text = 'Humidity';
	title.fontSize = 20;
    let dateAxis = chartHumidity.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartHumidity.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartHumidity.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartHumidity.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartHumidity.scrollbarX = scrollbarX;

    this.chartHumidity = chartHumidity;
	}
	/***
		Pressure Chart
	***/
	setupPressureChart(chartPressure, data)
	{
    chartPressure.paddingRight = 20;

	data = [];
    let visits = 30;
    for (let i = 1; i < 400; i++) {
      visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }

    chartPressure.data = data;
	let title = chartPressure.titles.create();
	title.text = 'Pressure';
	title.fontSize = 20;
    let dateAxis = chartPressure.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartPressure.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartPressure.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartPressure.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartPressure.scrollbarX = scrollbarX;

    this.chartPressure = chartPressure;
	}
	/***
		Ambience 1 Chart
	***/
	setupAmbience1Chart(chartAmbience1, data)
	{
    chartAmbience1.paddingRight = 20;

	data = [];
    let visits = 50;
    for (let i = 1; i < 239; i++) {
      visits += Math.round((Math.random() < 0.7 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }


    chartAmbience1.data = data;
	let title = chartAmbience1.titles.create();
	title.text = 'Ambient Light 1';
	title.fontSize = 20;
    let dateAxis = chartAmbience1.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartAmbience1.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartAmbience1.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartAmbience1.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartAmbience1.scrollbarX = scrollbarX;

    this.chartAmbience1 = chartAmbience1;
	}
	/***
		Ambience 2 Chart
	***/
	setupAmbience2Chart(chartAmbience2, data)
	{
    chartAmbience2.paddingRight = 20;

	data = [];
    let visits = 60;
    for (let i = 1; i < 600; i++) {
      visits += Math.round((Math.random() < 0.8 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }

    chartAmbience2.data = data;
	let title = chartAmbience2.titles.create();
	title.text = 'Ambient Light 2';
	title.fontSize = 20;
    let dateAxis = chartAmbience2.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartAmbience2.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartAmbience2.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartAmbience2.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartAmbience2.scrollbarX = scrollbarX;

    this.chartAmbience2 = chartAmbience2;
	}
	/***
		Moisture  Chart
	***/
	setupMoistureChart(chartMoisture, data)
	{
    chartMoisture.paddingRight = 20;

	data = [];
    let visits = 70;
    for (let i = 1; i < 143; i++) {
      visits += Math.round((Math.random() < 0.2 ? 1 : -1) * Math.random() * 10);
      data.push({ date: new Date(2020, 0, i), name: "name" + i, value: visits });
    }


    chartMoisture.data = data;
	let title = chartMoisture.titles.create();
	title.text = 'Moisture';
	title.fontSize = 20;
    let dateAxis = chartMoisture.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chartMoisture.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    let series = chartMoisture.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";

    series.tooltipText = "{valueY.value}";
    chartMoisture.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chartMoisture.scrollbarX = scrollbarX;

    this.chartMoisture = chartMoisture;
	}



componentWillUnmount() {
    if (this.chartTemperature) {
      this.chartTemperature.dispose();
   }
}
  render() {
    return (

<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Virtual Life Manager</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="/vlm" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="/" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															{this.state.locationName}
														</h3>
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter Locations" />&nbsp;
														{/*
														<a href="/create-device" class="col-sm-1 btn btn-success">New Device</a>&nbsp;
														<a href="/vlm-device-metrics" class="col-sm-1 btn btn-info">Dashboard</a> 
														*/}
							</div>
							<br />

						<hr />
						<div class="m-portlet__body  m-portlet__body--no-padding">
						<div class="row">
				      		<div id="chartTemperatureDiv" style={{ width: "33%", height: "300px" }}></div>
      						<div id="chartHumidityDiv" style={{ width: "33%", height: "300px" }}></div>
      						<div id="chartPressureDiv" style={{ width: "33%", height: "300px" }}></div>
      						<div id="chartAmbience1Div" style={{ width: "33%", height: "300px" }}></div>
      						<div id="chartAmbience2Div" style={{ width: "33%", height: "300px" }}></div>
      						<div id="chartMoistureDiv" style={{ width: "33%", height: "300px" }}></div>
      					</div>
						</div>
						</div>            
					</div>		
	            </div>	
            </div>
            
			</div>
			</div>
			
    );
  }
}